import { assertNonEmpty } from './assertNonEmpty.js';
const baseTableFunc = (table) => (input) => {
    const [, unit] = assertNonEmpty(table.find(([predicate]) => predicate(input)));
    return unit(input);
};
export const tableFunc = (table) => baseTableFunc(table.map(([p, o]) => [p, () => o]));
tableFunc.if = (predicate) => new TableFuncBuilder(undefined, predicate);
class TableFuncBuilder {
    parent;
    predicate;
    unit;
    get entry() {
        return [assertNonEmpty(this.predicate), assertNonEmpty(this.unit)];
    }
    constructor(parent, predicate, unit) {
        this.parent = parent;
        this.predicate = predicate;
        this.unit = unit;
    }
    if(predicate) {
        return new TableFuncBuilder(this, predicate);
    }
    then(unit) {
        return new TableFuncBuilder(this.parent, this.predicate, unit);
    }
    else(unit) {
        return baseTableFunc([...buildTable(this), [() => true, unit]]);
    }
}
const buildTable = (builder) => [
    ...(builder?.parent ? buildTable(builder.parent) : []),
    builder.entry,
];
//# sourceMappingURL=tableFunc.js.map